import PropTypes from 'prop-types'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { acGetAllAccessKeys, acPutAccessKey } from '../../../store/actions'
import { ERRORS } from '../../../store/constants'
import { ConfirmModal, Snackbar } from '../../default'

/**
 * @description Renders a modal component for updating an access key.
 * 
 * @author Maria Eduarda Franke
 * @param {boolean} open - Determines if the modal is open or not.
 * @param {function} onClose - Callback function to close the modal.
 * @param {object} selectedAccessKey - The selected access key object.
 * @returns {JSX.Element} The rendered modal component.
 */
const UpdateAccessKeyModal = ({ open, onClose, selectedAccessKey }) => {

    const dispatch = useDispatch()

    const [snackbarData, setSnackbarData] = useState({ open: false, severity: 'success', message: '' })

    const handleSnackbarClose = (_, reason) => {
        if (reason === 'clickaway') return
        setSnackbarData({ ...snackbarData, open: false })
    }

    const onConfirm = () => {
        dispatch(acPutAccessKey(selectedAccessKey.application_access_key_id))
            .then(() => {
                onClose()
                setSnackbarData({ open: true, severity: 'success', message: `Chave de acesso #${selectedAccessKey.application_access_key_id} ${selectedAccessKey.is_active ? 'desativada' : 'ativada'} com sucesso!` })
                dispatch(acGetAllAccessKeys())
                    .catch(error => console.error(error))
            })
            .catch(err => {
                console.error(err)
                onClose()
                setSnackbarData({ open: true, severity: 'error', message: `Não foi possível alterar a chave de acesso #${selectedAccessKey.application_access_key_id}. ${ERRORS[err.description]}` })
            })
    }

    return (
        <>
            <ConfirmModal
                open={open} onClose={onClose} onConfirm={onConfirm}
                title={selectedAccessKey?.is_active ? 'Desativar Chave de Acesso' : 'Ativar Chave de Acesso'}
                id={selectedAccessKey?.application_access_key_id}
                description={
                    selectedAccessKey?.is_active
                        ? `Você tem certeza que deseja desativar a chave de acesso #${selectedAccessKey?.application_access_key_id} ?`
                        : `Você tem certeza que deseja ativar a chave de acesso #${selectedAccessKey?.application_access_key_id} ?`
                }
            />
            <Snackbar
                open={snackbarData.open}
                onClose={handleSnackbarClose}
                severity={snackbarData.severity}
                message={snackbarData.message}
                vertical='bottom'
                horizontal='right'
                variant='filled'
                sx={{ mt: 1 }}
            />
        </>
    )

}

UpdateAccessKeyModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedAccessKey: PropTypes.object
}

export default UpdateAccessKeyModal